import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';
import { Button } from '@/shared/ui';

import { AttachPatientArgs } from '../../../../hooks';
import { AttachPatientModal } from '../AttachPatientModal/AttachPatientModal';

import styles from './PatientLinkRow.module.scss';

type PatientLinkRowProps = {
  encounter: TranscriptorEncounterResponse;
  onAttachPatient: (args: AttachPatientArgs) => Promise<void>;
};

export const PatientLinkRow: FC<PatientLinkRowProps> = (props) => {
  const { encounter, onAttachPatient } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (encounter.patient_id) {
    return null;
  }

  return (
    <div className={styles.row} data-component="encounter-patient-link-row">
      <Button
        variant="secondary"
        size="small"
        onClick={() => setIsModalOpen(true)}
      >
        <FormattedMessage
          id="encounters.details.attachPatient"
          defaultMessage="Attach patient"
        />
      </Button>

      <AttachPatientModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAttachPatient={onAttachPatient}
      />
    </div>
  );
};
